// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dealerIdTransform',
})
// all dealer ids are 5 digits, we will add zeros to the front
export class DealerIdTransformPipe implements PipeTransform {
    transform(value: number): string {
        if (String(value).length < 5) {
            return String(value).padStart(5, '0');
        }

        return String(value);
    }
}
